<template>
  <teleport to="body">

    <div
        class="title-tooltip-coin__dropdown"
        :class="{ 'title-tooltip-coin__dropdown--mini': get_isMini }"
        :style="{ top: `${get_position.top}px`, left: `${get_position.left}px` }"
        ref="tooltip"
    >
      <div class="title-tooltip-coin__coin-empty" v-if="get_isEmpty">
        <p>Монеты нет в базе</p>
      </div>
      <LoaderCircle v-else-if="get_isLoading" :size="20" :color="'blue'"/>
      <div v-else>
        <div class="title-tooltip-coin__header">
          <div class="title-tooltip-coin__project-container">
            <AvatarImage
                :size="32"
                :src="get_coinData.image || '/path/to/default.svg'"
                class="title-tooltip-coin__project-icon"
            />
            <div class="title-tooltip-coin__project-values">
              <div class="title-tooltip-coin__value-block">
                <span class="title-tooltip-coin__coin">{{ get_coinData.symbol || '--' }}</span>
                <span class="title-tooltip-coin__price">${{ get_coinData.price_usd || '--' }}</span>
              </div>
              <div class="title-tooltip-coin__value-block">
              <span :class="['title-tooltip-coin__change', get_changeClass]">
                {{ get_coinData.change_1d_usd || '--' }}%
              </span>
                <time class="title-tooltip-coin__time">за 24ч</time>
              </div>
            </div>
          </div>
          <div class="title-tooltip-coin__drops-icons">
            <div class="title-tooltip-coin__drops-ico">
              <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M3.06724 4.02908L3.91386 5.35511L3.92376 5.37041C4.37827 6.03733 4.38937 6.44384 4.05576 6.77744C3.94254 6.89079 3.87895 7.04445 3.87895 7.20465C3.87895 7.36486 3.94254 7.51851 4.05576 7.63186C4.11178 7.68801 4.17832 7.73256 4.25157 7.76295C4.32483 7.79335 4.40336 7.80899 4.48267 7.80899C4.56198 7.80899 4.64052 7.79335 4.71377 7.76295C4.78703 7.73256 4.85357 7.68801 4.90958 7.63186C5.701 6.83984 5.674 5.79972 4.92638 4.6978L3.54305 2.53025C3.29765 2.14595 2.73153 2.16185 2.50803 2.55905L1.42201 4.49199C1.05251 5.13319 0.859168 5.8607 0.861595 6.60074C0.861595 8.14907 2.07662 9.5 3.99996 9.5C5.92 9.5 7.13833 8.05457 7.13833 6.47984C7.13833 5.64642 6.92802 4.8745 6.50921 4.17579L4.45537 0.790517C4.4143 0.722733 4.36026 0.66371 4.29636 0.616825C4.23246 0.56994 4.15994 0.536112 4.08295 0.517276C4.00597 0.49844 3.92602 0.494966 3.84769 0.507052C3.76936 0.519139 3.69418 0.546548 3.62645 0.587713C3.48956 0.670892 3.39129 0.805029 3.35326 0.960637C3.31523 1.11624 3.34055 1.28058 3.42365 1.41753L5.47569 4.8001C5.7796 5.30681 5.9314 5.86362 5.9314 6.47984C5.9314 7.42846 5.20329 8.29187 3.99996 8.29187C2.77294 8.29187 2.06852 7.50886 2.06852 6.60074C2.06635 6.06965 2.20562 5.54755 2.47203 5.08811L3.06724 4.02908Z"
                    fill="#2563EB"/>
              </svg>
            </div>
            <a class="title-tooltip-coin__external-icon" :href="get_coinData.dropstab_url" target="_blank">
              <LinkIcon/>
            </a>
          </div>
        </div>
        <ul class="title-tooltip-coin__content-list">
          <li class="title-tooltip-coin__content-item">
            <span class="title-tooltip-coin__content-name">#{{ get_coinData.rank || '--' }}</span>
          </li>
          <li class="title-tooltip-coin__content-item">
            <span class="title-tooltip-coin__content-name">MCap</span>
            <span class="title-tooltip-coin__content-value">${{ get_coinData.market_cap || '--' }}</span>
          </li>
          <li class="title-tooltip-coin__content-item">
            <span class="title-tooltip-coin__content-name">FDV</span>
            <span class="title-tooltip-coin__content-value">${{ get_coinData.fdv || '--' }}</span>
          </li>
        </ul>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import {ref, computed, onMounted} from 'vue';
import {useStore} from 'vuex';
import AvatarImage from "@ui/Images/AvatarImage/AvatarImage.vue";
import LinkIcon from "@svg/LinkIcon.vue";
import LoaderCircle from "@ui/Loaders/LoaderCircle/LoaderCircle.vue";
import {Props} from './scripts/props'

const props = defineProps(Props());

const store = useStore();

// Состояние Vuex модуля
const tooltipSystem = computed(() => store.state.TooltipSystem);

// Получить данные коина
const get_coinData = computed(() => tooltipSystem.value.coinData);
// Получить данные коина
const get_isEmpty = computed(() => tooltipSystem.value.isEmpty);
// Получаем миниатюрный размер тултипа
const get_isMini = computed(() => tooltipSystem.value.isMini);
// Получить загрузку коина
const get_isLoading = computed(() => tooltipSystem.value.isLoading);
const get_changeClass = computed(() => store.getters['TooltipSystem/changeClass']);
// Получить расположение тултипа
const get_position = computed(() => store.state.TooltipSystem.position);

</script>

<style scoped lang="scss">
@import './styles/style';
</style>
